import type { TSerializedWidget } from 'src/entities/workspace/types';
import type {
  TFiltersSerializedInternalState,
  FiltersWidgetEntity,
} from 'src/pages/dashboard/features/filters-widget/FiltersWidget.entity';

export function serializeFiltersWidget(widget: FiltersWidgetEntity): TSerializedWidget {
  const internalState: TFiltersSerializedInternalState = {
    stateParams: { ...widget.stateParams },
  };

  return {
    isPinned: widget.isPinned,
    uuid: widget.uuid,
    type: widget.type,
    groupId: widget.groupId,
    size: {
      w: widget.size.w,
      h: widget.size.h,
    },
    position: {
      x: widget.position.x,
      y: widget.position.y,
    },
    isFullscreen: widget.isFullscreen,
    internalState,
  };
}
